import './style/index.less';
import PluginMemberSelect from './PluginMemberSelect';

export default PluginMemberSelect;
